import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=0d176b4b&lang=html&"
import script from "./form-table.vue?vue&type=script&lang=js&"
export * from "./form-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports